import ManagePatientsContainer from "../../../Component/Patients/ManagePatients/ManagePatients"

const ManagePatients = () => {
  return (
    <div className='page-body'>
      <ManagePatientsContainer />
    </div>
  )
}

export default ManagePatients